import { render, staticRenderFns } from "./prdDetailPage.vue?vue&type=template&id=6f54bfb0"
import script from "./prdDetailPage.vue?vue&type=script&lang=js"
export * from "./prdDetailPage.vue?vue&type=script&lang=js"
import style0 from "./prdDetailPage.vue?vue&type=style&index=0&id=6f54bfb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports